// extracted by mini-css-extract-plugin
export default {"data_box":"index_data_box_G-tP0","red":"index_red_0OHJU","green":"index_green_c3dmW","price":"index_price_cd8cO"};